function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.71.343v3.563h3.564L13.71.343z",
  fill: "#28293D"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.125 5.078a.586.586 0 01-.586-.586V0H4.141a1.76 1.76 0 00-1.758 1.758v16.484c0 .97.788 1.758 1.758 1.758h11.718a1.76 1.76 0 001.758-1.758V5.078h-4.492zm-5.41 8.453a.586.586 0 01-.9.75l-1.953-2.343a.586.586 0 010-.75l1.953-2.344a.586.586 0 01.9.75l-1.64 1.969 1.64 1.968zm3.622-4.127l-1.562 4.688a.586.586 0 01-1.112-.371l1.562-4.688a.586.586 0 111.112.371zm3.8 2.534l-1.953 2.343a.585.585 0 11-.9-.75l1.64-1.969-1.64-1.968a.586.586 0 11.9-.75l1.954 2.343a.586.586 0 010 .75z",
  fill: "#28293D"
});

function SvgFileCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgFileCode;